import React, { useState } from 'react';
import { useAuth } from './lib/auth';

const Login: React.FC = () => {
	const { login } = useAuth();
	const [apiKey, setApiKey] = useState('');
	const [error, setError] = useState('');

	const handleSubmit = (e?: React.FormEvent) => {
		e?.preventDefault();
		const ok = login(apiKey);
		if (!ok) {
			setError('Invalid API key. Please try again.');
			return;
		}
		setError('');
	};

	return (
		<div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
			<div className="bg-white rounded-lg border border-gray-200 shadow-sm p-8 w-full max-w-md">
				<div className="text-center mb-6">
					<div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
						<svg
							className="h-6 w-6 text-blue-600"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.8}
							stroke="currentColor">
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 0h10.5a2.25 2.25 0 012.25 2.25v6a2.25 2.25 0 01-2.25 2.25H6.75a2.25 2.25 0 01-2.25-2.25v-6a2.25 2.25 0 012.25-2.25z"
							/>
						</svg>
					</div>
					<h1 className="text-xl font-bold text-gray-900">Decision Engine Monitoring Tool</h1>
					<p className="text-sm text-gray-500 mt-1">Enter your API key to continue.</p>
				</div>

				<form onSubmit={handleSubmit} className="space-y-3">
					<input
						type="password"
						autoFocus
						value={apiKey}
						onChange={(e) => {
							setApiKey(e.target.value);
							if (error) setError('');
						}}
						placeholder="Enter API key..."
						className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
					/>

					{error && (
						<p className="text-sm text-red-600" role="alert">
							{error}
						</p>
					)}

					<button
						type="submit"
						disabled={!apiKey.trim()}
						className="w-full px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
						Unlock
					</button>
				</form>
			</div>
		</div>
	);
};

export default Login;
